module.exports = __webpack_public_path__ + "static/media/2.6f326275.png";